export var TLClockTimeRoutes = {
    '/clock-time': {
        'loginRequired': true,
        'showGlobalSearch': true,
        'name': 'appLayout.schedule.clock-time',
        'type': 'frontend',
        'abstract': true,
        'views': {
            'body': {
                component: 'ctEmployerComponent'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        'onEnter': ['TeamScheduleService', function (TeamScheduleService) {
            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    if (!TeamScheduleService.isClockTimeAppEnabled()) {
                        hRedirect('/schedule');
                    }
                });
        }],
        'route_dependencies': [
            {
                type: 'chunk',
                loader: function () {
                    return import('./tl-clock-time.module.js');
                }
            }
        ],
    },
    '/timesheet?date&employee_review&violation&type&tab&userId&warningStatus&employeeTags&showRemoved': {
        'loginRequired': true,
        'showGlobalSearch': true,
        'name': 'appLayout.schedule.clock-time.timesheet',
        'type': 'frontend',
        'reloadOnSearch': false,
        'views': {
            'clock-time-body': {
                component: 'ctEmployerTimesheetComponent'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "params": {
            tab: {
                dynamic: true,
                value: "ALL"
            },
            employee_review: {
                dynamic: true
            },
            violation: {
                dynamic: true
            },
            date: {
                dynamic: true
            },
            type: {
                dynamic: true
            },
            userId: {
                dynamic: true
            }
        },
        'headTags': [
            {
                'tag': 'title',
                'attributes': {},
                'value': 'Harri | Time Sheet'
            }
        ],
        'route_dependencies': [
        ],
    },
    '/pay-sheet?paysheet_type_id&paysheet_id': {
        'loginRequired': true,
        'showGlobalSearch': true,
        'name': 'appLayout.schedule.clock-time.pay-sheet',
        'type': 'frontend',
        'views': {
            'clock-time-body': {
                component: 'ctEmployerPaySheetComponent'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        'headTags': [
            {
                'tag': 'title',
                'attributes': {},
                'value': 'Harri | Pay Data Sheet'
            }
        ],
        'route_dependencies': [
            {
                type: 'chunk',
                loader: () => {
                    return import("../../../../hmodules/paysheet-payrun/paysheet-payrun.module.js");
                }
            },
        ],
    },
    '/announcements': {
        'loginRequired': true,
        'showGlobalSearch': true,
        'name': 'appLayout.schedule.clock-time.announcements',
        'type': 'frontend',
        'views': {
            'clock-time-body': {
                component: 'ctEmployerAnnouncementsComponent'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        'headTags': [
            {
                'tag': 'title',
                'attributes': {},
                'value': 'Harri | Announcements'
            }
        ]
    },
    '/feedback': {
        'loginRequired': true,
        'showGlobalSearch': true,
        'name': 'appLayout.schedule.clock-time.feedback',
        'type': 'frontend',
        'views': {
            'clock-time-body': {
                component: 'ctEmployerFeedbackComponent'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        'headTags': [
            {
                'tag': 'title',
                'attributes': {},
                'value': 'Harri | Feedback'
            }
        ]
    },
    '/alerts': {
        'loginRequired': true,
        'showGlobalSearch': true,
        'name': 'appLayout.schedule.clock-time.alerts',
        'type': 'frontend',
        'views': {
            'clock-time-body': {
                component: 'ctEmployerAlertsComponent'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        'headTags': [
            {
                'tag': 'title',
                'attributes': {},
                'value': 'Harri | Alerts'
            }
        ]
    },
};
